import hashUtils from 'app-lib/hashUtils'
import { links } from 'bzx-common/src/config/appConfig'
import { Button, ButtonClipboard, Icon, Tooltip } from 'bzx-common/src/ui-framework'
import _ from 'lodash'
import { observer } from 'mobx-react'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import DashboardVM from '../DashboardVM'
import { ReactComponent as CoinGecco } from './coin-gecco.svg'
import { ReactComponent as Govern } from './govern.svg'
import { ReactComponent as OokiTokenIllustration } from './ooki-flowchart.svg'
import { ReactComponent as Stake } from './stake.svg'

export function OurToken({ vm }: { vm: DashboardVM }) {
  return (
    <div className="panel--simple md-padded-2 txt-center">
      <div className="panel--alternative txt-read-optimized center-block padded-1 margin-bottom-2">
        <div className="">
          <b className="flex-center">
            <Icon name="token-ooki" className="margin-right-05" /> OOKI is a multi-chain token
          </b>
          <ul className="list-none font-mono our-token__contracts">
            {vm.ookiInfo.map((info) => (
              <li key={info.address}>
                <Icon
                  name={info.chainIcon.name}
                  color={info.chainIcon.color}
                  top={6}
                  bgColor="var(--color-bg-default)"
                  bgCircle
                  bgPadding={3}
                  size={32}
                />
                <ExternalLink
                  className="link--discreet margin-h-1ch"
                  href={info.ookiExplorerLink}
                  title={info.address}>
                  {hashUtils.shortHash(info.address, 8, 6)}
                </ExternalLink>
                <ButtonClipboard text={info.address} top={-4} />
              </li>
            ))}
          </ul>
        </div>
      </div>

      <h3 className="margin-bottom-2 txt-slogan">The OokiDAO {'&'} Tokenized Ownership Model</h3>
      <p className="txt-explanation txt-read-optimized center-block">
        The OOKI Token was designed to kickstart liquidity, network effects, and create long term
        aligned stakeholders. OOKI is a governance token first and foremost. An active and vibrant
        community of stakeholders collectively advancing the protocol is at the heart of OOKI.{' '}
        <ExternalLink className="txt-blue-aim" href={links.docs.daoGovernance}>
          Learn More
        </ExternalLink>
      </p>
      <div className="our-token__container">
        <OokiTokenIllustration className="padded-1 margin-bottom-1" />

        <div className="grid-2-col margin-bottom-2">
          <div className="flex-col">
            <Stake height={100} />
            <p className="margin-v-2 txt-explanation">
              Earn a percentage of OOKI protocol fees when you stake OOKI Tokens.
            </p>
            <ExternalLink
              href={links.ookiCoingecko}
              className="btn btn--blue btn--medium flex-center flex-col-end">
              View info <CoinGecco className="margin-left-1" />
            </ExternalLink>
          </div>
          <div className="flex-col">
            <Govern height={100} />
            <p className="margin-v-2 txt-explanation">
              Vote through OOKI DAO on proposals relating to governance.
            </p>
            <Button
              variant="blue"
              className="flex-center flex-col-end"
              data-tip
              data-for="buy-ooki-popup"
              data-event="click">
              Buy OOKI <Icon name="token-ooki" className="margin-left-1" />
            </Button>
            <Tooltip
              id="buy-ooki-popup"
              clickable={true}
              data-event-off="click"
              effect="solid"
              globalEventOff="click"
              isCapture={true}
              place="top"
              className="tooltip__info padded-1"
              delayHide={200}>
              <h3 className="margin-top-05">Buy Ooki on:</h3>
              <ul className="list-none list-spaced-2">
                {_.map(links.buyOoki, (link) => {
                  return (
                    <li key={link.title}>
                      <ExternalLink className="btn btn--menu" href={link.url}>
                        <Icon name={link.icon} color={link.color} className="margin-right-1" />{' '}
                        {link.title}
                      </ExternalLink>
                    </li>
                  )
                })}
              </ul>
            </Tooltip>
          </div>
        </div>
      </div>
      {/* TODO: WE WILL SHOW STATS ONCE WE HAVE THEM. */}
      {/* <div className="bg-alternative txt-read-optimized md-padded-2 center-block txt-title">
        <div className="flex-between">
          <p className="txt-subtitle-super txt-muted">Price</p>
          <p>
            <span className="txt-muted">$</span>0.24
          </p>
        </div>
        <div className="flex-between">
          <p className="txt-subtitle-super txt-muted">Circulating Supply</p>
          <p>
            <span className="txt-muted">$</span>140,610,067
          </p>
        </div>
        <div className="flex-between">
          <p className="txt-subtitle-super txt-muted">Total Supply</p>
          <p>
            <span className="txt-muted">$</span>1,030,000,000
          </p>
        </div>
      </div> */}
    </div>
  )
}

export default observer(OurToken)
